import items from './items';
import simpleViewAttributes from './simpleViewAttributes';

const root = {
	items,
	simpleViewAttributes
};

export default root;
